/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as CreditRouteImport } from './routes/credit'
import { Route as DirectoryRouteImport } from './routes/directory'
import { Route as SolutionsAmyloCloudRouteImport } from './routes/solutions/amylo-cloud'
import { Route as SolutionsMmseRouteImport } from './routes/solutions/mmse'
import { Route as SolutionsMorphRouteImport } from './routes/solutions/morph'
import { Route as SolutionsPascalHomeRouteImport } from './routes/solutions/pascal-home'
import { Route as SolutionsPascalMedRouteImport } from './routes/solutions/pascal-med'
import { Route as SolutionsScstRouteImport } from './routes/solutions/scst'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditRoute = CreditRouteImport.update({
  id: '/credit',
  path: '/credit',
  getParentRoute: () => rootRouteImport,
} as any)
const DirectoryRoute = DirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsAmyloCloudRoute = SolutionsAmyloCloudRouteImport.update({
  id: '/solutions/amylo-cloud',
  path: '/solutions/amylo-cloud',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsMmseRoute = SolutionsMmseRouteImport.update({
  id: '/solutions/mmse',
  path: '/solutions/mmse',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsMorphRoute = SolutionsMorphRouteImport.update({
  id: '/solutions/morph',
  path: '/solutions/morph',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsPascalHomeRoute = SolutionsPascalHomeRouteImport.update({
  id: '/solutions/pascal-home',
  path: '/solutions/pascal-home',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsPascalMedRoute = SolutionsPascalMedRouteImport.update({
  id: '/solutions/pascal-med',
  path: '/solutions/pascal-med',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsScstRoute = SolutionsScstRouteImport.update({
  id: '/solutions/scst',
  path: '/solutions/scst',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/credit': typeof CreditRoute
  '/directory': typeof DirectoryRoute
  '/solutions/amylo-cloud': typeof SolutionsAmyloCloudRoute
  '/solutions/mmse': typeof SolutionsMmseRoute
  '/solutions/morph': typeof SolutionsMorphRoute
  '/solutions/pascal-home': typeof SolutionsPascalHomeRoute
  '/solutions/pascal-med': typeof SolutionsPascalMedRoute
  '/solutions/scst': typeof SolutionsScstRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/credit': typeof CreditRoute
  '/directory': typeof DirectoryRoute
  '/solutions/amylo-cloud': typeof SolutionsAmyloCloudRoute
  '/solutions/mmse': typeof SolutionsMmseRoute
  '/solutions/morph': typeof SolutionsMorphRoute
  '/solutions/pascal-home': typeof SolutionsPascalHomeRoute
  '/solutions/pascal-med': typeof SolutionsPascalMedRoute
  '/solutions/scst': typeof SolutionsScstRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/credit': typeof CreditRoute
  '/directory': typeof DirectoryRoute
  '/solutions/amylo-cloud': typeof SolutionsAmyloCloudRoute
  '/solutions/mmse': typeof SolutionsMmseRoute
  '/solutions/morph': typeof SolutionsMorphRoute
  '/solutions/pascal-home': typeof SolutionsPascalHomeRoute
  '/solutions/pascal-med': typeof SolutionsPascalMedRoute
  '/solutions/scst': typeof SolutionsScstRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/credit'
    | '/directory'
    | '/solutions/amylo-cloud'
    | '/solutions/mmse'
    | '/solutions/morph'
    | '/solutions/pascal-home'
    | '/solutions/pascal-med'
    | '/solutions/scst'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/credit'
    | '/directory'
    | '/solutions/amylo-cloud'
    | '/solutions/mmse'
    | '/solutions/morph'
    | '/solutions/pascal-home'
    | '/solutions/pascal-med'
    | '/solutions/scst'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/credit'
    | '/directory'
    | '/solutions/amylo-cloud'
    | '/solutions/mmse'
    | '/solutions/morph'
    | '/solutions/pascal-home'
    | '/solutions/pascal-med'
    | '/solutions/scst'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  CreditRoute: typeof CreditRoute
  DirectoryRoute: typeof DirectoryRoute
  SolutionsAmyloCloudRoute: typeof SolutionsAmyloCloudRoute
  SolutionsMmseRoute: typeof SolutionsMmseRoute
  SolutionsMorphRoute: typeof SolutionsMorphRoute
  SolutionsPascalHomeRoute: typeof SolutionsPascalHomeRoute
  SolutionsPascalMedRoute: typeof SolutionsPascalMedRoute
  SolutionsScstRoute: typeof SolutionsScstRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credit': {
      id: '/credit'
      path: '/credit'
      fullPath: '/credit'
      preLoaderRoute: typeof CreditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/directory': {
      id: '/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof DirectoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/amylo-cloud': {
      id: '/solutions/amylo-cloud'
      path: '/solutions/amylo-cloud'
      fullPath: '/solutions/amylo-cloud'
      preLoaderRoute: typeof SolutionsAmyloCloudRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/mmse': {
      id: '/solutions/mmse'
      path: '/solutions/mmse'
      fullPath: '/solutions/mmse'
      preLoaderRoute: typeof SolutionsMmseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/morph': {
      id: '/solutions/morph'
      path: '/solutions/morph'
      fullPath: '/solutions/morph'
      preLoaderRoute: typeof SolutionsMorphRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/pascal-home': {
      id: '/solutions/pascal-home'
      path: '/solutions/pascal-home'
      fullPath: '/solutions/pascal-home'
      preLoaderRoute: typeof SolutionsPascalHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/pascal-med': {
      id: '/solutions/pascal-med'
      path: '/solutions/pascal-med'
      fullPath: '/solutions/pascal-med'
      preLoaderRoute: typeof SolutionsPascalMedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/scst': {
      id: '/solutions/scst'
      path: '/solutions/scst'
      fullPath: '/solutions/scst'
      preLoaderRoute: typeof SolutionsScstRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  CreditRoute: CreditRoute,
  DirectoryRoute: DirectoryRoute,
  SolutionsAmyloCloudRoute: SolutionsAmyloCloudRoute,
  SolutionsMmseRoute: SolutionsMmseRoute,
  SolutionsMorphRoute: SolutionsMorphRoute,
  SolutionsPascalHomeRoute: SolutionsPascalHomeRoute,
  SolutionsPascalMedRoute: SolutionsPascalMedRoute,
  SolutionsScstRoute: SolutionsScstRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
